module.exports = __webpack_public_path__ + "static/media/bellabyte-camisa-uniforme-personalizado.b40307f3.jpg";